import md from 'markdown-it';
import { useState } from 'react';


export const ReadingOrder = ( {data, note} : any) => {

  const [displayAuthor, setDisplayAuthor] = useState(false)

  const handleClick = () => {
    setDisplayAuthor(!displayAuthor);
  }

  return (
    <section className='mt-8 mb-8'>
      <h2 className='text-2xl text-heresy-primary' id='reading-order'>
        Reading Order
        <span className='pl-2 text-sm '><button onClick={handleClick}>{displayAuthor ? "[hide author]" : "[show author]"}</button></span>
      </h2>
      <div className='text-heresy-secondary pb-2'>
      <span>Legend: </span><span className='font-extrabold'>Novels</span><span>;</span><span className='font-extralight '> Novellas (anthology)</span><span>;</span><span className='font-extralight opacity-60'> Short Stories (anthology)</span>
      </div>
      
      <ol className='list-decimal ml-8'>
        {data.map((bookObject: any, index: number) => (
          <li key={'x-' + index} className={`leading-6 lg:prose-xl ${bookObject['type'] === 'novel' ? 'font-extrabold' : bookObject['type'] === 'short-story' ? 'font-extralight opacity-60' : bookObject['type'] === 'novella' ? 'font-extralight' : '' }`}>
            {bookObject[bookObject['type']].title}
            <span className='font-thin text-sm pl-2'>{displayAuthor && bookObject[bookObject['type']].author && "by " + bookObject[bookObject['type']].author}</span>
          </li>
        ))}
      </ol>
      <div className='prose prose-invert lg:prose-xl pt-4' dangerouslySetInnerHTML={{ __html: md().render(note) }}/>
    </section>);
}